// extracted by mini-css-extract-plugin
export default {"wrapper":"landing_wrapper__eCzS7","heading":"landing_heading__bTIZZ","table-header":"landing_table-header__bS3lT","label":"landing_label__2ljuU"};